// src/app may not import the generated API client, so this mirrors the
// TimesheetRowDto fields the split reads.
export interface IOvertimeSplitRow {
  total?: number;
  payCode?: { isOvertime?: boolean };
}

export interface ISplitHours {
  regularHours: number;
  overtimeHours: number;
}

const isOvertimeRow = (row: IOvertimeSplitRow): boolean =>
  row.payCode?.isOvertime === true;

/** @registry Partitions timesheet rows into regular vs overtime by payCode.isOvertime, preserving row shape. */
export const partitionRowsByOvertime = <T extends IOvertimeSplitRow>(
  rows: T[] | undefined,
): { regular: T[]; overtime: T[] } => {
  const regular: T[] = [];
  const overtime: T[] = [];
  (rows ?? []).forEach((row) => {
    if (isOvertimeRow(row)) {
      overtime.push(row);
    } else {
      regular.push(row);
    }
  });
  return { regular, overtime };
};

/** @registry Splits timesheet row totals into regular vs overtime hours by payCode.isOvertime. */
export const splitHoursByOvertime = (
  rows: IOvertimeSplitRow[] | undefined,
): ISplitHours => {
  const { regular, overtime } = partitionRowsByOvertime(rows);
  const sum = (list: IOvertimeSplitRow[]): number =>
    list.reduce((acc, row) => acc + Number(row.total || 0), 0);
  return {
    regularHours: sum(regular),
    overtimeHours: sum(overtime),
  };
};
